import { Catalog } from 'models';
import { ServiceRequestTypes } from '../actions/serviceRequestAction';

interface State {
  loading: boolean;
  listCatalog: Catalog[];
}

const defaultState: State = {
  loading: false,
  listCatalog: [],
};

const serviceRequestReducer = (state = defaultState, action: any): State => {
  const { loading, listCatalog } = action;

  switch (action.type) {
    case ServiceRequestTypes.SET_LOADING:
      return {
        ...state,
        loading,
      };
    case ServiceRequestTypes.GET_LIST_CATALOG:
      return {
        ...state,
        loading: true,
      };
    case ServiceRequestTypes.GET_LIST_CATALOG_SUCCESS:
      return {
        ...state,
        listCatalog,
        loading: false,
      };
    default:
      return state;
  }
};

export default serviceRequestReducer;
